import {
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_PAGE,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_SIZE,
    SET_QUALITY_CONTROL_STATISTICS_FILTER,
    SET_QUALITY_CONTROL_STATISTICS_FIRST_PAGE,
    SET_QUALITY_CONTROL_STATISTICS_LOADING,
    UPDATE_QUALITY_CONTROL_STATISTICS_FILTER,
    UPDATE_QUALITY_CONTROL_STATISTICS_SORT_FIELDS,
    CLEAR_QUALITY_CONTROL_STATISTICS_FILTERS,
    SET_QUALITY_CONTROL_STATISTICS_UI_FILTERS,
    SHOW_EXPORT_QUALITY_CONTROL_STATISTICS_LOADING,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_PAGE,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_SIZE,
} from "../types/typesQualityControlStatistics";

export function setQualityControlStatisticsCurrentPage(state: any) {
    return {
        type: SET_CURRENT_QUALITY_CONTROL_STATISTICS_PAGE,
        payload: state
    }
}

export function setQualityControlStatisticsCurrentPageSize(state: any) {
    return {
        type: SET_CURRENT_QUALITY_CONTROL_STATISTICS_SIZE,
        payload: state
    }
}

export function setQualityControlStatisticsFirstPage(state: any) {
    return {
        type: SET_QUALITY_CONTROL_STATISTICS_FIRST_PAGE,
        payload: state
    }
}

export function setQualityControlStatisticsFilter(payload: any) {
    return {
        type: SET_QUALITY_CONTROL_STATISTICS_FILTER,
        payload: payload,
    };
}

export function showQualityControlStatisticsLoader(payload: any) {
    return {
        type: SET_QUALITY_CONTROL_STATISTICS_LOADING,
        payload: payload,
    };
}

export function updateQualityControlStatisticsSortFields(updatedFields: any) {
    return {
        type: UPDATE_QUALITY_CONTROL_STATISTICS_SORT_FIELDS,
        payload: updatedFields,
    };
}

export const updateQualityControlStatisticFilter = (field: string, value: any) => ({
    type: UPDATE_QUALITY_CONTROL_STATISTICS_FILTER,
    payload: {field, value}
});

export const resetQualityControlStatisticFilters = () => ({
    type: CLEAR_QUALITY_CONTROL_STATISTICS_FILTERS
});

export function setQualityControlStatisticsUiFilters(filters: Record<string, any>) {
    return {
        type: SET_QUALITY_CONTROL_STATISTICS_UI_FILTERS,
        payload: filters,
    };
}

export function showQualityControlStatisticsExportLoader(payload: boolean) {
    return {
        type: SHOW_EXPORT_QUALITY_CONTROL_STATISTICS_LOADING,
        payload,
    };
}

export function setQualityControlStatisticsFilesCurrentPage(state: number) {
    return {
        type: SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_PAGE,
        payload: state,
    };
}

export function setQualityControlStatisticsFilesCurrentPageSize(state: number) {
    return {
        type: SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_SIZE,
        payload: state,
    };
}
